import React, { CSSProperties } from "react";

import styles from "./StepIndicator.module.scss";

interface StepIndicatorProps {
  stages: string[];
  stageIndex: number; // stage in range of [0, num_stages - 1]
}

const StepIndicator = ({ stages, stageIndex }: StepIndicatorProps) => {
  return (
    <div className={styles.container}>
      <ol className={styles.indicators}>
        {stages.map((stage, i) => (
          <li key={stage} className={styles.indicator}>
            <div className={styles.indicatorContent}>
              <div
                className={`${styles.circle} ${i < stageIndex ? styles.completed : i == stageIndex ? styles.current : ""}`}
              />
              <span
                className={`${styles.label} ${i == stageIndex && styles.current}`}
              >
                {stage}
              </span>
            </div>
          </li>
        ))}
      </ol>
      <div className={styles.lineContainer}>
        <div className={styles.baseLine} />
        <div
          className={styles.highlightLine}
          style={
            {
              "--step-progress": `${(100 * stageIndex) / (stages.length - 1)}%`,
            } as CSSProperties
          }
        />
      </div>
    </div>
  );
};

export default StepIndicator;
